module.exports = __webpack_public_path__ + "static/media/Radio-Inactive.10a6d2dc.svg";